// Copyright (c) 2025 by Audere

import { LabelTask } from "../../label/labelTypes";
import {
  commonLabelingTasks,
  commonLabelingTypes,
  commonQuestions,
  translationLabelingTask,
  translationQuestions,
} from "./common";

export const mangroveLabelingTypes = [
  ...commonLabelingTypes,
  {
    id: "isiZuluTranslationLabeling",
    name: "Translation labeling isiZulu",
    description: "Label the translation quality of isiZulu language",
    taskIDs: ["qualityOfTranslationLabeling"],
  },
] as const;

const mangroveLabelingTasks: LabelTask[] = [
  ...commonLabelingTasks,
  ...translationLabelingTask,
];

const mangroveQuestions = [...commonQuestions, ...translationQuestions];

export const mangroveLabelingSchemaV1 = {
  labelingTypes: mangroveLabelingTypes,
  labelingTasks: mangroveLabelingTasks,
  labelingQuestions: mangroveQuestions,
  labelingSchemaVersion: "mangroveLabelingSchemaV1",
};
